export const admin = {
  common: {
    loading: 'Wird geladen…',
    loadingOrganiser: 'Veranstalter wird geladen…',
    couldNotLoadEvents: 'Veranstaltungen konnten nicht geladen werden',
    noEventsAvailable: 'Keine Veranstaltungen verfügbar',
    getTickets: 'Tickets sichern',
    soldOut: 'Ausverkauft',
    free: 'Kostenlos',
    view: 'Ansehen',
    online: 'Online',
    ticketsLeft: 'Noch {remaining} übrig',
    saveEvent: 'Veranstaltung merken',
    removeFromSaved: 'Aus Merkliste entfernen',
    datesCount: '{count} Termine',
  },
  app: {},
  organiser: {
    loadErrorTitle: 'Veranstalterinformationen konnten nicht geladen werden',
    eventsByOrganiser: 'Veranstaltungen von {organiserName}',
    noEventsBody: 'Schauen Sie bald wieder vorbei für neue Veranstaltungen.',
  },
  instancePicker: {
    title: 'Wählen Sie Ihre Veranstaltung',
    subtitle: 'Wählen Sie einen Veranstalter, um Tickets zu durchsuchen und zu kaufen.',
    browseAllTitle: 'Alle Veranstaltungen durchsuchen',
    browseAllDescription: 'Veranstaltungen aller Veranstalter an einem Ort ansehen',
    browseEvents: 'Veranstaltungen durchsuchen',
  },
  directory: {
    loadingEvents: 'Veranstaltungen werden geladen...',
    searchPlaceholder: 'Veranstaltungen, Veranstalter, Orte durchsuchen…',
    title: 'Veranstaltungsverzeichnis',
    seoTitle: 'Veranstaltungsverzeichnis — Alle Veranstaltungen durchsuchen',
    seoDescription: 'Entdecken Sie Veranstaltungen von Veranstaltern auf der gesamten Plattform. Durchsuchen, filtern und Tickets sichern.',
    jsonldListName: 'Veranstaltungsverzeichnis',
    jsonldListDescription: 'Veranstaltungen von mehreren Veranstaltern',
    eventsCountFromAllOne: '1 Veranstaltung von allen Veranstaltern',
    eventsCountFromAllOther: '{count} Veranstaltungen von allen Veranstaltern',
    browseEventsFromAll: 'Veranstaltungen von allen Veranstaltern durchsuchen',
    sortUpcoming: 'Zuerst bevorstehende',
    sortPriceLowHigh: 'Preis: aufsteigend',
    sortNameAZ: 'Name A–Z',
    inPerson: 'Vor Ort',
    saved: 'Gemerkt',
    locationPlaceholder: 'Ort',
    allLocations: 'Alle Orte',
    clearFilters: 'Filter zurücksetzen ({count})',
    categoryAll: 'Alle',
    noSavedEvents: 'Keine gemerkten Veranstaltungen',
    noSavedEventsBody: 'Merken Sie Veranstaltungen, indem Sie auf das ♡ einer Veranstaltungskarte klicken.',
    noEventsFound: 'Keine Veranstaltungen gefunden',
    noEventsFoundFilteredBody: 'Versuchen Sie eine andere Suche oder setzen Sie einige Filter zurück.',
    noEventsFoundBody: 'Derzeit sind keine Veranstaltungen im Verzeichnis gelistet.',
    loadMoreEvents: 'Weitere Veranstaltungen laden',
    showingCount: 'Zeige {shown} von {total}',
    organiserNotFound: 'Veranstalter nicht gefunden',
    backToDirectory: 'Zurück zum Verzeichnis',
    upcomingEvents: 'Bevorstehende Veranstaltungen',
    eventsListedCountOne: '1 Veranstaltung gelistet',
    eventsListedCountOther: '{count} Veranstaltungen gelistet',
    noEventsListed: 'Keine Veranstaltungen gelistet',
    noEventsListedBody: 'Dieser Veranstalter hat noch keine Veranstaltungen im Verzeichnis gelistet.',
    allEventsButton: 'Alle Veranstaltungen',
    organiserSeoTitle: '{organiserName} — Veranstaltungen',
    organiserSeoDescriptionFallback: 'Entdecken Sie bevorstehende Veranstaltungen von {organiserName}.',
  },
  ticketingEnabledGuard: {
    title: 'Ticketverkauf nicht verfügbar',
    description: 'Dieser Veranstalter bietet derzeit keinen Ticketverkauf an.',
  },
};
